<template>
  <v-app id="inspire" class="bodyPadding">
    <mo-header></mo-header>
    <v-content>		
		<ds-head></ds-head>		
		<ds-list></ds-list>
    </v-content>
  </v-app>
</template>

<script>

	import DsHead from './Header.vue';	
	import DsList from './List.vue';
	export default {
		data () {
			return {
		
			}		
		},
		components: {
			DsHead,			
			DsList
		}
	}
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css'
</style>